/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';


export default declareLinkedEntity({
    entity: "flowScriptDefs",
    graphQL: "FlowScriptDef",
    name: "Flow Scripts",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowScriptDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Script Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Name",
            type: "string",
            defaultValue: "",
        },
        frontend: {
            name: "Allow use in frontend",
            type: "boolean",
        },
        libraryDef: {
            name: "Library Definition",
            type: "relation",
            to: () => types['libraryDefs'],
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        script: {
            name: "Script",
            type: "javascript",
            defaultValue: "",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
            visibility: (data) => { return !data['libraryDef_id'] && !data['libraryDef']; },
        },
        testScript: {
            name: "Test Script",
            type: "javascript",
            defaultValue: "",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
            visibility: (data) => { return !data['libraryDef_id'] && !data['libraryDef']; },
        },        
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
